import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import EventList from "./EventList";

createRoot(document.getElementById("tmt-event-list")).render(
  <StrictMode>
    <EventList />
  </StrictMode>
);
